<app-landing-header></app-landing-header>

<div class="landing-header-spacer"></div>

<div class="landing-content">
  <ng-container *ngIf="isRootPath() || isEmailVerify(); else otherRoutes">
    <app-landing-ntrip-caster></app-landing-ntrip-caster>
  </ng-container>
  <ng-template #otherRoutes>
    <router-outlet></router-outlet>
  </ng-template>
</div>

<app-landing-footer></app-landing-footer>
